import { GET_ATS_REPORT_FOR_MISSION_ROLE } from "graphql/queries";
import { useQueryData } from "hooks";

/**
 * useAtsReportForMissionRole
 *
 * @param {String} slug
 * @param {String} mode
 */
export default function useAtsReportForMissionRole({ slug, mode }) {
  const { data, loading, error } = useQueryData({
    queryName: GET_ATS_REPORT_FOR_MISSION_ROLE,
    variables: {
      slug,
      mode,
    },
    skip: !slug || !mode,
  });

  return {
    data: data?.atsReportForMissionRole,
    loading,
    error,
  };
}
